<template>
	<div class="register_progress_callback_table">
		<div >
			<template>
			    <el-table
				    :data="tableData"
				    :span-method="objectSpanMethod"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="require"
					        label="是否必须"
					        width="200px">
				      	</el-table-column>
				      	<el-table-column
				        	prop="name"
				        	label="参数名"
				        	width="200px">
				      	</el-table-column>
                        <el-table-column
				        	prop="type"
				        	label="类型"
				        	width="200px">
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="说明">
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
	</div>
</template>
<script>
	export default{
        props: {
            propsTableData:null,
        },
		data(){
			return{
                tableData:[],
			}
		},
		methods:{
			Trim(str){ 
					return str.replace(/(^\s*)|(\s*$)/g, ""); 
			},
			objectSpanMethod({ row, column, rowIndex, columnIndex }){
				console.log(row, column, rowIndex, columnIndex)
				if (columnIndex === 0) {
			        // if (rowIndex % 2 === 0) {
			        //     return {
			        //       rowspan: 2,
			        //       colspan: 1
			        //     };
			        // } else {
			        //     return {
			        //       rowspan: 0,
			        //       colspan: 0
			        //     };
			        // }
			        if (row.rowspan) {
			            return {
			              rowspan: row.rowspan,
			              colspan: row.colspan
			            };
			        } else {
			            return {
			              rowspan: 0,
			              colspan: 0
			            };
			        }
		        }else if(columnIndex === 1){
					if (row.rowspan) {
			            return {
			              rowspan: row.rowspan,
			              colspan: row.colspan
			            };
			        } else {
			            return {
			              rowspan: 0,
			              colspan: 0
			            };
			        }
				}else if(columnIndex === 2){
					if (row.rowspan) {
			            return {
			              rowspan: row.rowspan,
			              colspan: row.colspan
			            };
			        } else {
			            return {
			              rowspan: 0,
			              colspan: 0
			            };
			        }
				}
			}
		},
		mounted(){
			console.log(1111111111111111111111111111111111111111111111111111111)
			if (this.propsTableData) {
				for(var i=0;i<this.propsTableData.length;i++){
					console.log(this.propsTableData)
					this.propsTableData[i].msg =this.Trim(this.propsTableData[i].msg).toString()
				}
				this.tableData = this.propsTableData;
			}
		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.register_progress_callback_table{
		//margin:5px 0 30px 30px;
		margin:5px 0 30px 0;
		thead{
			tr{
				th{
					padding:15px 0;
					background: #F5F7FA;
					color:#333;
				}
			}
			
		}
		.cell{
			text-align: center;
			color:#2c3e50;;
			.table_msg{
				//text-align: left;
				.table_msg_list{
					padding: 2px 0;
				}
			}
		}
		tbody{
			td{
				padding:8px 0;
			}
		}	
		
	}
</style>	


// WEBPACK FOOTER //
// src/components/frmRequestParamsTableNew.vue